import AdTimer from "./adTimer/adTimer";
import AdIcon from "./adIcon/adIcon1";
import {useEffect} from "react";import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { setCurrentTime, setPlay } from "../../../../../redux/slices/controllerSlice";
import { conditions } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const SoundVolume = dynamic(() => import("../soundVolume/soundVolume"));

const Advertisement = () => {
    const dispatch = useAppDispatch();
    const { play } = useAppSelector(({ controller: { play } }) => ({ play }), shallowEqual);

    useEffect(() => {
        return () => {
            dispatch(setCurrentTime(0))
            dispatch(setPlay(!play));
        }
    }, [])

    return (
        <div className="pl-absolute pl-w-full pl-h-full pl-z-[1000]">
            <AdTimer/>
            <AdIcon/>
            {!conditions(ConditionName.isIOS) && <SoundVolume/>}
        </div>
    )
}

export default Advertisement;
